import { SimplePageLayout } from 'modules/page';
import { FC, memo } from 'react';
import { useSelector } from 'react-redux';

import PasswordResetFinalStepModule from '../../containers/PasswordResetFinalStepModule/PasswordResetFinalStepModule';
import { getDocumentTitle } from '../../selectors/pageSelectors';

const ResetPasswordFinalStepPageContent: FC = () => {
    const documentTitle = useSelector(getDocumentTitle);

    return (
        <SimplePageLayout documentTitle={documentTitle}>
            <PasswordResetFinalStepModule />
        </SimplePageLayout>
    );
};

export default memo(ResetPasswordFinalStepPageContent);
